import { createSlice } from '@reduxjs/toolkit';
import { useInjectReducer } from 'redux-injectors';
import { DynamicLayoutVersion } from '../../../types/types';

export interface ConfigurationState {
    quizes: any;
    styleRequest: any;
    notification: any;
    payment: {
        taxPercentage: string;
        currency: string;
    };
    stockCheck: {
        availableThreshold: number;
        unAvailableThreshold: number;
    };
    termsOfServices: {
        stylistManualDocs: String;
    };
    invoice: {
        phone: string;
        vatNumber: string;
        sellerName: string;
        arabicSellerName: string;
    };
    stitcher: {
        dynamicLayoutVersion: DynamicLayoutVersion;
        objectDetectCategories: string;
    };
    requestQuizzes: any;
    storeConfig?: any;
    reviewersWithSimpleFlow?: any;
}
export const initialState: ConfigurationState = {
    quizes: {},
    styleRequest: {},
    notification: {},
    payment: {
        taxPercentage: '',
        currency: '',
    },
    stockCheck: {
        availableThreshold: 0,
        unAvailableThreshold: 0,
    },
    termsOfServices: {
        stylistManualDocs: '',
    },
    invoice: {
        phone: '',
        vatNumber: '',
        sellerName: '',
        arabicSellerName: '',
    },
    requestQuizzes: {},
    stitcher: {
        dynamicLayoutVersion: DynamicLayoutVersion.v1,
        objectDetectCategories: '',
    },
    storeConfig: {},
    reviewersWithSimpleFlow: {},
};

const slice = createSlice({
    name: 'configuration',
    initialState,
    reducers: {
        setConfiguration: (state, action) => {
            state.quizes = { ...action.payload?.quizes };
            state.styleRequest = { ...action.payload?.styleRequest };
            state.notification = { ...action.payload?.notification };
            state.payment = { ...action.payload?.payment };
            state.stockCheck = { ...action.payload?.stockCheck };
            state.termsOfServices = { ...action.payload?.termsOfServices };
            state.invoice = { ...action.payload?.invoice };
            state.requestQuizzes = { ...action.payload?.requestQuizzes };
            state.stitcher = { ...action.payload?.stitcher };
            state.storeConfig = { ...action.payload?.storeConfig };
            state.reviewersWithSimpleFlow = { ...action.payload?.reviewersWithSimpleFlow };
        },
    },
});

export const { setConfiguration } = slice.actions;

export const useConfiguration = () => {
    useInjectReducer({ key: slice.name, reducer: slice.reducer });
    return { actions: slice.actions };
};
